export default __webpack_public_path__ + "static/media/space_part2.6f30fe2c.png";